export const ISOLATED_PAGE_APP_CONTAINER_ID = 'isolated-page-app-container';
